export type RelistAdditionalFieldsToRenderProps = {
  renderSquareFootageField: boolean;
  renderAcceptApplicationsField: boolean;
  renderPetsField: boolean;
  renderPhotosField: boolean;
  renderToursField: boolean;
  renderAmenitiesField: boolean;
  renderHidePropertyAddressField: boolean;
  renderAllowContactByPhoneField: boolean;
  renderCostsAndFeesField: boolean;
};

const RelistAdditionalFieldsToRender = ({
  renderSquareFootageField = false,
  renderAcceptApplicationsField = false,
  renderPetsField = false,
  renderPhotosField = false,
  renderToursField = false,
  renderAmenitiesField = false,
  renderHidePropertyAddressField = false,
  renderAllowContactByPhoneField = false,
  renderCostsAndFeesField = false,
}: Partial<RelistAdditionalFieldsToRenderProps> = {}): RelistAdditionalFieldsToRenderProps => ({
  renderSquareFootageField,
  renderAcceptApplicationsField,
  renderPetsField,
  renderPhotosField,
  renderToursField,
  renderAmenitiesField,
  renderHidePropertyAddressField,
  renderAllowContactByPhoneField,
  renderCostsAndFeesField,
});

export default RelistAdditionalFieldsToRender;
